import React from "react";
import { Box } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import OwnerWorkspaceNavigation from "./components/OwnerWorkspaceNavigation";

export default function OwnerWorkspace() {
  const location = useLocation();
  const isAgenda = /^\/dashboard\/owner\/?$/.test(location.pathname);

  return (
    <Box sx={{ width: "100%", height: { xs: "auto", md: "calc(100dvh - 68px)" }, minHeight: 0, display: "flex", bgcolor: "background.default", overflow: { xs: "visible", md: "hidden" } }}>
      <OwnerWorkspaceNavigation />
      <Box
        component="section"
        data-owner-mobile-surface="true"
        sx={{
          flex: "1 1 auto",
          minWidth: 0,
          minHeight: 0,
          width: "100%",
          overflow: isAgenda ? { xs: "visible", md: "hidden" } : { xs: "visible", md: "auto" },
          px: { xs: .6, sm: .85, md: 1 },
          pt: { xs: .6, md: .8 },
          pb: { xs: "calc(70px + env(safe-area-inset-bottom))", md: .8 },
          "& > *": { maxWidth: "none !important", mx: "0 !important" },
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
